class DetailsModal extends HTMLElement {
  constructor() {
    super();

    // Cache elements (may be missing depending on markup)
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.closeButton = this.querySelector('button[type="button"]');

    // If required structure is missing, do not bind (avoid runtime errors)
    if (!this.detailsContainer || !this.summaryToggle) return;

    // Bind methods once
    this.onSummaryClick = this.onSummaryClick.bind(this);
    this.onBodyClickEvent = this.onBodyClick.bind(this);
    this.close = this.close.bind(this);

    // Events
    this.detailsContainer.addEventListener('keyup', (event) => {
      if (event.code && event.code.toUpperCase() === 'ESCAPE') this.close();
    });

    this.summaryToggle.addEventListener('click', this.onSummaryClick);

    // Close button is optional
    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.close);
    }

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return !!(this.detailsContainer && this.detailsContainer.hasAttribute('open'));
  }

  onSummaryClick(event) {
    event.preventDefault();
    const details = event.target.closest('details');
    if (!details) return;

    details.hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    // Close if click is outside this component OR on overlay
    if (!this.contains(event.target) || event.target.classList?.contains('modal-overlay')) {
      this.close(false);
    }
  }

  open(event) {
    if (!this.detailsContainer) return;

    const details = event.target.closest('details') || this.detailsContainer;
    details.setAttribute('open', true);

    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    // trapFocus utilities might not exist in all contexts; guard them
    const trapTarget = this.detailsContainer.querySelector('[tabindex="-1"]');
    const firstInput = this.detailsContainer.querySelector('input:not([type="hidden"])');

    if (typeof trapFocus === 'function' && trapTarget) {
      trapFocus(trapTarget, firstInput || trapTarget);
    }
  }

  close(focusToggle = true) {
    // Make close safe even if structure is missing or already removed
    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(focusToggle ? this.summaryToggle : null);
    }

    if (this.detailsContainer) {
      this.detailsContainer.removeAttribute('open');
    }

    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

// Avoid "already defined" error during theme reloads
if (!customElements.get('details-modal')) {
  customElements.define('details-modal', DetailsModal);
}
